<template>
  <div class="menu-wrapper">
    <ul class="menu_ul">
      <li
        v-if="roleId != 10 && roleId !== 12"
        class="unclick-item"
      >
        <img class="menu_icon" src="/static/images/icons/team_profile.svg" />
        <span>{{$t('profile')}}</span>
      </li>

      <li class="sub_menu_wrapper" v-if="roleId !== 4 && roleId != 10 && roleId !== 12">
        <ul class="sub_menu">
          <li @click="settings('profile')" :class="{active_page:active_tab=='profile'}">
            <span>{{$t('userProfile')}}</span>
          </li>

          <li @click="settings('companyProfile')" :class="{active_page:active_tab=='companyProfile'}">
            <span>{{$t('companyProfile')}}</span>
          </li>

          <li @click="settings('changePassword')" :class="{active_page:active_tab=='changePassword'}">
            <span>{{$t('changePassword')}}</span>
          </li>
        </ul>
      </li>

      <div v-if="roleId === 1 || roleId ===  roleInfo['Super Admin'] || roleId === roleInfo['RA Admin']" class="line"></div>

      <li
        v-if="roleId !== 4 && roleId != 10 && roleId !== 12 && (roleId === 1 || roleId === roleInfo['RA Admin'])"
        class="unclick-item d-flex"
      >
        <img class="menu_icon" src="/static/images/icons/team_account_settings.svg" alt="settings-icon"/>
        <span>{{$t('accountSettings')}}</span>
      </li>
      <li class="sub_menu_wrapper" v-if="roleId !== 4 && roleId != 10 && roleId !== 12 && (roleId === 1 || roleId ===  roleInfo['Super Admin'] || roleId === roleInfo['RA Admin'])">
        <ul class="sub_menu">
          <li
            v-if="roleId == 1 || roleId == 5 || roleId == 9 || roleId ===  roleInfo['Super Admin'] || roleId === roleInfo['RA Admin']"
            @click="settings('team')"
            :class="{active_page:active_tab=='team'}"
          >
            <span>{{$t('team')}}</span>
          </li>
          <li v-if="roleId == 1 || roleId == 5 || roleId == 9 || roleId ===  roleInfo['Super Admin']" @click="settings('services')" :class="{active_page:active_tab=='services'}">
            <span>{{$t('services')}}</span>
          </li>
          <li v-if="roleId == 1 || roleId == 5 || roleId == 9 || roleId ===  roleInfo['Super Admin']" @click="settings('billing')" :class="{active_page:active_tab=='billing'}">
            <span>{{$t('billing')}}</span>
          </li>
        </ul>
      </li>

      <div class="line"></div>

      <!-- <li
        @click="settings('tour')"
        :class="{active_page:active_tab=='tour'}"
        v-if="roleId !== 4 && roleId !== 7 && roleId !== 10 && roleId !== 12"
      >
        <img class="menu_icon" src="/static/images/icons/team_virtual_tour.svg" alt="virtual-icon"/>
        <span>Virtual Tour</span>
      </li> -->
      <li @click="settings('tour')" :class="{active_page:active_tab=='tour'}">
        <img class="menu_icon" src="/static/images/icons/team_tour.svg" />
        <span>{{ $t('virtualTour')}}</span>
      </li>

      <li @click="settings('logout')" :class="{active_page:active_tab=='logout'}">
        <img class="menu_icon" src="/static/images/icons/team_logout.svg" />
        <span>{{$t('logout')}}</span>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  props: ['activeTab', 'roleId', 'isDashboardCustomizable', 'roleInfo'],
  data() {
    return {
      active_tab: '',
      isREP: JSON.parse(localStorage.getItem('userData')).account_type_id === 2 || JSON.parse(localStorage.getItem('userData')).account_type_id === 4,
      dashboardCustomizable: null,
      // language: '',
    };
  },
  watch: {
    activeTab() {
      this.active_tab = this.activeTab;
    },
  },
  methods: {
    settings(data) {
      if (data === 'logout') {
        socket.removeAllListeners(`alertSaveMultiRegistrationDetails_${localStorage.getItem('userId')}`);
        document.cookie = 'Authorization=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        document.cookie = 'redirect_url=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        localStorage.clear();
        sessionStorage.clear();
        this.$router.push({ name: 'login' });
      } else this.$emit('menuClicked', data);
    },
  },
};
</script>
<style scoped>
/* issue 7 */
.unclick-item {
  cursor: default !important;
}
.line {
  border-bottom: 1px solid #828282;
  margin: 0 56px 0px 16px;
  opacity: 0.2;
}
.inmetro_company_profile {
  width: 16px;
  height: 16px;
}
.pt_account_settings {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  padding: 14px 0px 0px 24px;
}
.account_settings {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  padding: 14px 20px 10px 24px;
  color: #3E3E3E;
}
.active_page {
  background-color: #E6E6E6;
  font-weight: 400 !important;
  border-right: 4px solid #CA0123;
}
.menu-wrapper {
  color: #3E3E3E;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
}
.menu_ul {
  list-style: none;
  padding: 0px;
}
.menu_ul > li {
  padding: 5px 10px;
  cursor: pointer;
  min-height: 32px;
  color: #000000;
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
}
.sub_menu {
  list-style: none;
  padding: 0px;
}
.sub_menu > li {
  padding: 6px 8px 6px 74px;
  cursor: pointer;
  margin: 2px 0px 2px 0px;
}
.sub_menu_wrapper {
  padding: 5px 0 8px !important;
  cursor: unset !important;
}
.menu_icon {
  margin: 0px 18px;
  vertical-align: top;
  width: 24px;
  height: 24px;
}
</style>
